// src/pages/ProjectDetail/ProjectDetail.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { BsBuildings } from "react-icons/bs";
import { RiStackLine } from "react-icons/ri";

import {
  FiCheckCircle,
  FiMapPin,
  FiCalendar,
  FiHome,
  FiLayers,
} from "react-icons/fi";

import ProjectGallery from "./ProjectGallery";
import ProjectAdvisorCard from "./ProjectAdvisorCard";
import ProjectCard from "./ProjectCard";
import "./ProjectDetail.css";
import apis from "../../utils/apis";
import httpAction from "../../utils/httpAction";
import convertPrice from "../../utils/convertAmount";
import useGeneral from "../../hooks/useGeneral";
export default function ProjectDetail() {
  const [pro, setPro] = useState({});
  const [simi, setSimi] = useState([]);
  const { slug } = useParams();
  const { goToTop } = useGeneral();
  goToTop();
  const params = new URLSearchParams(window.location.search);
  const id = params.get("id");
  const getSinglePro = async () => {
    const data = {
      url: apis().getProjectDetail + "?id=" + id,
    };
    const result = await httpAction(data);

    if (result?.status) {
      setPro(result?.projenct);
      setSimi(result?.similar);
    }
  };
  useEffect(() => {
    getSinglePro();
  }, [id]);

  const data = useMemo(() => {
    return {
      id: "PJ-2207",
      title: "HB Heights — Signature High-Rise",
      location: "Gulberg, Lahore",
      status: "Pre-Launch",
      startingPrice: "PKR 1.9 Crore",
      tag: "High ROI",
      delivery: "Q4 2027",
      towers: 2,
      units: 480,
      floors: "38 Floors",
      unitTypes: ["Studio", "1 Bed", "2 Bed", "Penthouse"],
      description:
        "A premium vertical living project designed for modern lifestyles. Smart layouts, curated amenities, and a location built for long-term value. Ideal for end-users and investors seeking stability and growth.",
      highlights: [
        "Prime access to main boulevard + city hotspots",
        "Modern lobby, concierge, and smart security systems",
        "Lifestyle amenities: gym, pool, lounge, co-working",
        "Strong rental demand potential for investors",
      ],
      amenities: [
        "24/7 Security",
        "Basement Parking",
        "High-Speed Elevators",
        "Power Backup",
        "Gym & Pool",
        "Kids Play Area",
        "Retail Area",
        "Maintenance Staff",
      ],
      paymentPlan: [
        { label: "Booking", value: "10%" },
        { label: "Confirmation", value: "10%" },
        { label: "Monthly Installments", value: "60%" },
        { label: "On Possession", value: "20%" },
      ],
      images: [
        "https://images.unsplash.com/photo-1496307653780-42ee777d4833?auto=format&fit=crop&w=1800&q=80",
        "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1800&q=80",
        "https://images.unsplash.com/photo-1449844908441-8829872d2607?auto=format&fit=crop&w=1800&q=80",
      ],
    };
  }, [slug]);

  const advisor = useMemo(
    () => ({
      name: "Jean Baptist",
      role: "Investment Advisor",
      exp: "7+ Years Experience",
      phone: "+923001234567",
      email: "projects@realty.com",
      whatsapp: "#",
      image: "https://randomuser.me/api/portraits/men/35.jpg",
    }),
    []
  );

  const similar = useMemo(
    () => [
      {
        id: 21,
        name: "Skyline Residences",
        location: "DHA Phase 6, Lahore",
        status: "Under Construction",
        statusKey: "construction",
        startingPrice: "PKR 2.7 Crore",
        towers: 3,
        units: 620,
        height: "45 Floors",
        tag: "Prime Location",
        image:
          "https://images.unsplash.com/photo-1449844908441-8829872d2607?auto=format&fit=crop&w=1600&q=80",
      },
      {
        id: 22,
        name: "Central Towers",
        location: "MM Alam, Lahore",
        status: "Ready",
        statusKey: "ready",
        startingPrice: "PKR 3.2 Crore",
        towers: 1,
        units: 210,
        height: "28 Floors",
        tag: "Move-in",
        image:
          "https://images.unsplash.com/photo-1460317442991-0ec209397118?auto=format&fit=crop&w=1600&q=80",
      },
      {
        id: 23,
        name: "Urban Peak Apartments",
        location: "Johar Town, Lahore",
        status: "Pre-Launch",
        statusKey: "prelaunch",
        startingPrice: "PKR 1.4 Crore",
        towers: 2,
        units: 390,
        height: "32 Floors",
        tag: "",
        image:
          "https://images.unsplash.com/photo-1487958449943-2429e8be8625?auto=format&fit=crop&w=1600&q=80",
      },
    ],
    []
  );

  return (
    <div className="pjd">
      <ProjectGallery
        images={pro?.data?.images?.map((item) => apis().localUrl + item?.url)}
        status={pro?.data?.construction}
        title={pro?.data?.title}
        location={pro?.data?.location}
        startingPrice={convertPrice(pro?.data?.price) + "/SQ.FT"}
        number={pro?.user?.mobile}
        id={pro?._id}
        // tag={data.tag}
      />

      <div className="container">
        <div className="pjd__crumbs">
          <Link className="pjd__crumb" to="/">
            ← Back to Projects
          </Link>
          <span className="pjd__crumbMuted">Slug: {slug}</span>
        </div>

        <div className="pjd__layout">
          {/* Main */}
          <main className="pjd__main">
            {/* Key strip */}
            <section className="pjd__strip">
              <div className="pjd__kv">
                <span className="pjd__k">Project ID</span>
                <span className="pjd__v">{pro?._id?.substring(0, 6)}</span>
              </div>
              <div className="pjd__kv">
                <span className="pjd__k">Delivery</span>
                <span className="pjd__v">
                  <FiCalendar /> {pro?.data?.completionDate}
                </span>
              </div>
              <div className="pjd__kv">
                <span className="pjd__k">Towers</span>
                <span className="pjd__v">
                  <FiLayers /> {pro?.data?.towers}
                </span>
              </div>
              <div className="pjd__kv">
                <span className="pjd__k">Units</span>
                <span className="pjd__v">{pro?.data?.units}+</span>
              </div>
              <div className="pjd__kv">
                <span className="pjd__k"> Floors</span>
                <span className="pjd__v">
                  {" "}
                  <BsBuildings /> {pro?.data?.floors}{" "}
                </span>
              </div>
            </section>
            <div className="pjd__kv">
              <span className="pjd__k">Unit Types</span>
              <span className="pjd__v">
                {pro?.data?.categories?.map((item, index) => (
                  <>
                    <FiHome /> {item}
                  </>
                ))}
              </span>
            </div>
            {/* Overview */}
            <section className="pjd__panel">
              <h2 className="pjd__h">Overview</h2>
              <p className="pjd__p">{pro?.data?.des}</p>

              <div className="pjd__locLine">
                <FiMapPin />
                <span>{pro?.data?.city}</span>
              </div>
            </section>

            {/* Highlights */}
            <section className="pjd__panel">
              <h2 className="pjd__h">Project Highlights</h2>
              <div className="pjd__list">
                {pro?.data?.highlights.map((x) => (
                  <div className="pjd__li" key={x}>
                    <FiCheckCircle /> {x}
                  </div>
                ))}
              </div>
            </section>

            {/* Amenities */}
            <section className="pjd__panel">
              <h2 className="pjd__h">Amenities</h2>
              <div className="pjd__amenities">
                {pro?.data?.ammenities?.map((a) => (
                  <div className="pjd__amenity" key={a}>
                    <FiCheckCircle /> {a}
                  </div>
                ))}
              </div>
            </section>

            {/* Payment Plan */}
            <section className="pjd__panel">
              <h2 className="pjd__h">Payment Plan</h2>
              <div className="pjd__plan">
                <div className="pjd__planItem">
                  <span className="pjd__planLabel">Booking</span>
                  <span className="pjd__planVal">{pro?.data?.booking} %</span>
                </div>
                <div className="pjd__planItem">
                  <span className="pjd__planLabel">Confirmation</span>
                  <span className="pjd__planVal">
                    {pro?.data?.confirmation} %
                  </span>
                </div>
                <div className="pjd__planItem">
                  <span className="pjd__planLabel">Installment</span>
                  <span className="pjd__planVal">
                    {pro?.data?.installment} %
                  </span>
                </div>
                <div className="pjd__planItem">
                  <span className="pjd__planLabel">Posession</span>
                  <span className="pjd__planVal">
                    {pro?.data?.possession} %
                  </span>
                </div>
              </div>

              <div className="pjd__planNote">
                Note: This is a sample breakdown. Final plan depends on unit
                type and availability.
              </div>
            </section>

            {/* Location placeholder */}
            <section className="pjd__panel">
              <h2 className="pjd__h">Location</h2>
              <div className="pjd__map">
                <iframe
                  src={pro?.data?.mapLink}
                  width="100%"
                  height="100%"
                  // style="border:0;"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </section>

            {/* Similar */}
          </main>

          {/* Sticky advisor */}
          <ProjectAdvisorCard id={pro?._id} advisor={pro?.user} />
        </div>
        <div style={{ marginBottom: "0.6rem" }}>
          <section className="pjd__panel">
            <h2 className="pjd__h">Similar Projects</h2>
            <div className="pjd__similarGrid">
              {simi?.map((x) => (
                <ProjectCard key={x.id} item={x} />
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
